import { render, staticRenderFns } from "./LogDetailsAmbulance.vue?vue&type=template&id=5ff4c9f9&"
import script from "./LogDetailsAmbulance.vue?vue&type=script&lang=js&"
export * from "./LogDetailsAmbulance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports